export function getView(event) {
  return event.appointment.booking.length > 0 ? 'Scheduled' : 'Unscheduled'
}
